import React from "react";
import HRNavbar from "../HR/Routes/Navbar";
import { Navigate } from "react-router-dom";
import { getUser } from "../../Utils/helper";
import DashboardContentShell from "./DashboardContentShell";

const HRLayout = () => {
  let userAuth = getUser() ? getUser() || "" : null;
  return userAuth?.employee?.role === "HR" ||
    userAuth?.employee?.role === "admin" ? (
    <React.Fragment>
      <HRNavbar />
      <DashboardContentShell />
    </React.Fragment>
  ) : (
    <Navigate to={`/`} />
  );
};
export default HRLayout;
